// hooks/useDataFreshnessTableColumns.ts

import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { DataFreshness } from '../../types/data-freshness';
import { formatDateByLocale } from '../LabelPerf/components/TrackPerformance/utils';

export function useDataFreshnessTableColumns() {
  const { t } = useTranslation();

  return useMemo(() => {
    const columnHelper = createColumnHelper<DataFreshness>();

    return [
      columnHelper.accessor('category', {
        id: 'category',
        header: () => (
          <div className="flex items-center gap-sm">
            <span>{t('table.category', 'Category')}</span>
          </div>
        ),
        cell: (info) => (
          <div className="truncate py-md pl-px" title={info.getValue()}>
            {info.getValue()}
          </div>
        ),
        meta: { className: 'w-[180px]' },
      }),
      columnHelper.accessor('name', {
        id: 'name',
        header: () => (
          <div className="flex items-center gap-sm">
            <span>{t('table.name', 'Name')}</span>
          </div>
        ),
        cell: (info) => (
          <div
            className="truncate py-md pl-sm font-semibold"
            title={info.getValue()}
          >
            {info.getValue()}
          </div>
        ),
        meta: { className: 'w-[420px]' },
      }),
      columnHelper.accessor('freshness', {
        id: 'freshness',
        header: () => (
          <div className="flex items-center gap-sm">
            <span>{t('table.freshness', 'Freshness')}</span>
          </div>
        ),
        cell: (info) => (
          <div className="truncate py-md pl-sm" title={info.getValue()}>
            {formatDateByLocale(info.getValue(), { includeTime: true })}
          </div>
        ),
        meta: { className: 'w-[220px]' },
      }),
    ];
  }, [t]);
}
